import React from 'react';
import c from 'classnames';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import {
  CopyToClipboard,
  Share,
} from '@uncinc/uncinc-react-kitchen-sink';

import './style.scss';

const ShareTitle = (props) => {
  const { t } = useTranslation();

  const { title } = props;

  return (
    <div className="icon-after icon-share icon-variant-0">
      {title || t('components.social_share.title')}
    </div>
  );
};

const SocialShare = (props) => {
  const { t } = useTranslation();

  const { title, className } = props;

  const classNames = c('SocialShare', className);

  return (
    <div className={classNames}>
      <Share
        title={<ShareTitle title={title} />}
        withLabels
        items={[
          'facebook',
          'twitter',
          'linkedin',
          'whatsapp',
          'mail',
          'copy',
        ]}
        customItems={{
          copy: (
            <CopyToClipboard
              text={window.location.href}
              icon="link"
              copyText={t('components.social_share.labels.copy')}
              copiedText={t('components.social_share.labels.copied')}
            />
          ),
        }}
      />
    </div>
  );
};

SocialShare.defaultProps = {
  title: '',
  className: '',
};

SocialShare.propTypes = {
  title: PropTypes.string,
  className: PropTypes.string,
};

export default SocialShare;
